import { getSPDataWithoutParams } from './services'

export const SUPPORT_TECHNICAL_API_ROOT = '/api/secure/cc/support/technical'

// Backend RoleRegistry projection: every role with its registry portal ids and
// the client portal grants (portalId + pending) that ship on
// LoginData.availablePortals, plus the Control Center login-gate role list.
export function getPortalRoleMatrix() {
  return getSPDataWithoutParams(`${SUPPORT_TECHNICAL_API_ROOT}/portal-role-matrix`)
}
